import { createSlice } from "@reduxjs/toolkit";

export const TENDER360_VIEW_KEYS = Object.freeze({
  DASHBOARD: "dashboard",
  BIDDER_PROFILE: "bidderProfile",
  COMPETITOR_MATRIX: "competitorMatrix",
  MISSED_OPPORTUNITIES: "missedOpportunities",
  LOST_TENDER_EVALUATION: "lostTenderEvaluation",
  RATE_ANALYSIS: "rateAnalysis",
  DEPARTMENT_INSIGHTS: "departmentInsights",
  STATE_STATISTICS: "stateStatistics",
  ANALYTICAL_REPORT: "analyticalReport",
});

const initialState = { byKey: {} };

const tender360ViewsSlice = createSlice({
  name: "tender360Views",
  initialState,
  reducers: {
    replaceTender360View(state, action) {
      const { viewKey, value } = action.payload || {};
      if (!viewKey) return;
      state.byKey[viewKey] = value && typeof value === "object" ? value : {};
    },
    patchTender360View(state, action) {
      const { viewKey, changes } = action.payload || {};
      if (!viewKey || !changes || typeof changes !== "object") return;
      state.byKey[viewKey] = {
        ...(state.byKey[viewKey] || {}),
        ...changes,
      };
    },
    clearTender360View(state, action) {
      const viewKey = action.payload;
      if (viewKey) delete state.byKey[viewKey];
    },
    resetTender360Views() {
      return initialState;
    },
  },
});

export const {
  replaceTender360View,
  patchTender360View,
  clearTender360View,
  resetTender360Views,
} = tender360ViewsSlice.actions;

export const selectTender360View = (state, viewKey) =>
  state?.tender360Views?.byKey?.[viewKey] || {};

export default tender360ViewsSlice.reducer;

